(() => {
  if (customElements.get('blog-load-more')) {
    return;
  }

  class BlogLoadMore extends HTMLElement {
    constructor() {
      super();
      this.loadMoreButton = this.querySelector('[data-load-more-trigger]');
      this.loadMoreText = this.querySelector('[data-load-more-text]');
      this.loader = this.querySelector('[data-loader]');
      this.articlesContainer = document.querySelector('#blog-articles-container');
      
      // Get data attributes
      this.sectionId = this.dataset.sectionId;
      this.nextUrl = this.dataset.nextUrl;
      this.totalPages = parseInt(this.dataset.totalPages);
      this.currentPage = parseInt(this.dataset.currentPage);
      this.blogHandle = this.dataset.blogHandle;
      this.articlesPerPage = parseInt(this.dataset.articlesPerPage);
      this.layout = this.dataset.layout;
      this.showImage = this.dataset.showImage === 'true';
      this.showDate = this.dataset.showDate === 'true';
      this.showAuthor = this.dataset.showAuthor === 'true';
      this.imageHeight = this.dataset.imageHeight;
      this.mediaAspectRatio = this.dataset.mediaAspectRatio;
      this.showExcerpt = this.dataset.showExcerpt === 'true';

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => this.fetchMoreArticles());
      }
    }

    async fetchMoreArticles() {
      if (!this.nextUrl || this.currentPage >= this.totalPages) {
        this.hideLoadMoreButton();
        return;
      }

      this.setLoadingState(true);

      try {
        // Calculate the next page number
        const nextPage = this.currentPage + 1;
        
        // Try Shopify Sections Rendering API first
        const sectionsUrl = new URL('/apps/sections-renderer', window.location.origin);
        sectionsUrl.searchParams.set('sections', this.sectionId);
        sectionsUrl.searchParams.set('section_id', this.sectionId);
        sectionsUrl.searchParams.set('page', nextPage.toString());
        sectionsUrl.searchParams.set('articles_per_page', this.articlesPerPage.toString());
        sectionsUrl.searchParams.set('blog_handle', this.blogHandle);

        const response = await fetch(sectionsUrl.toString(), {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          
          if (data.sections && data.sections[this.sectionId]) {
            const sectionHtml = data.sections[this.sectionId];
            this.appendNewArticles(sectionHtml, nextPage);
            return;
          }
        }

        // Fallback to traditional AJAX approach if sections API doesn't work
        await this.fallbackFetch();

      } catch (error) {
        console.error('Error loading more articles:', error);
        // Fallback to traditional AJAX approach
        await this.fallbackFetch();
      } finally {
        this.setLoadingState(false);
      }
    }

    async fallbackFetch() {
      try {
        // Build the next page URL
        const nextPageUrl = new URL(this.nextUrl, window.location.origin);
        nextPageUrl.searchParams.set('page', (this.currentPage + 1).toString());
        nextPageUrl.searchParams.set('section_id', this.sectionId);

        const response = await fetch(nextPageUrl.toString());
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const html = await response.text();

        // Parse the HTML and extract new articles
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newArticles = doc.querySelectorAll('.blog-articles__article');
        const newLoadMore = doc.querySelector('blog-load-more');

        if (newArticles.length > 0 && this.articlesContainer) {
          newArticles.forEach(article => {
            this.articlesContainer.appendChild(article.cloneNode(true));
          });
        }

        // Update load more data
        if (newLoadMore) {
          this.nextUrl = newLoadMore.dataset.nextUrl;
          this.currentPage = parseInt(newLoadMore.dataset.currentPage);
          this.totalPages = parseInt(newLoadMore.dataset.totalPages);
          
          // Check if we've reached the last page
          if (this.currentPage >= this.totalPages) {
            this.hideLoadMoreButton();
          }
        } else {
          this.hideLoadMoreButton();
        }

      } catch (error) {
        console.error('Fallback fetch error:', error);
        this.hideLoadMoreButton();
      }
    }

    appendNewArticles(sectionHtml, nextPage) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      
      const newArticles = doc.querySelectorAll('.blog-articles__article');
      
      if (newArticles.length > 0 && this.articlesContainer) {
        newArticles.forEach(article => {
          this.articlesContainer.appendChild(article.cloneNode(true));
        });
      }

      // Update current page
      this.currentPage = nextPage;
      
      // Check if we've reached the last page
      if (this.currentPage >= this.totalPages) {
        this.hideLoadMoreButton();
      }
    }

    setLoadingState(isLoading) {
      if (isLoading) {
        this.loadMoreButton.disabled = true;
        this.loadMoreText.classList.add('hide');
        this.loader.classList.remove('hide');
      } else {
        this.loadMoreButton.disabled = false;
        this.loadMoreText.classList.remove('hide');
        this.loader.classList.add('hide');
      }
    }

    hideLoadMoreButton() {
      this.style.display = 'none';
    }
  }

  customElements.define('blog-load-more', BlogLoadMore);
})(); 